import React, { useEffect } from "react";
import DefaultDashboard from "./contents/default";
import AdminDashboard from "./contents/admin";
import ManagerDashboard from "./contents/manager";
import Header from "../../components/shared/header";
import ReportDashboard from "../Reports/Dashboard";
import { ArrowLongRightIcon } from "@heroicons/react/24/solid";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../store/company";

const Dashboard = () => {
    const dispatch = useDispatch();
    const userState = useSelector((state) => state.auth);
    const user = userState?.userData?.user;
    const isUserHaveNoPermission = (permissions) => {
        return permissions ? permissions === 0 : false;
    };
    const dashBoardContent = (roles) => {
        if (roles.includes("Super Admin") || roles.includes("Admin")) {
            return <AdminDashboard />;
        }
        if (roles.includes("Manager")) {
            return <ManagerDashboard />;
        }
        return <DefaultDashboard />;
    };

    useEffect(() => {
        if (!user?.company_id) {
            dispatch(fetchData());
        }
    }, [dispatch, user]);

    const pageTitle = "Dashboard";

    const breadcrumbItems = [{ label: pageTitle, url: "/" }];

    const cards = [
        {
            value: 0,
            subTitle: "Total Request",
            borderColor: "bg-blue-200",
            btnColor: "bg-blue-500",
            btnHoverColor: "bg-blue-700",
        },
        {
            value: 0,
            subTitle: "Total Sold",
            borderColor: "bg-green-200",
            btnColor: "bg-green-500",
            btnHoverColor: "bg-green-700",
        },
        {
            value: 0,
            subTitle: "Total Booked",
            borderColor: "bg-purple-200",
            btnColor: "bg-purple-500",
            btnHoverColor: "bg-purple-700",
        },
        {
            value: 0,
            subTitle: "Total Cancel",
            borderColor: "bg-orange-200",
            btnColor: "bg-orange-500",
            btnHoverColor: "bg-orange-700",
        },
    ];

    return (
        <div className="flex flex-col gap-y-3">
            <Header items={breadcrumbItems} pageTitle={pageTitle} />
            <ReportDashboard />
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                {cards.map(
                    (
                        {
                            value,
                            subTitle,
                            borderColor,
                            btnColor,
                            btnHoverColor,
                        },
                        index
                    ) => (
                        <div
                            key={index + 1}
                            className="bg-white rounded-lg overflow-hidden shadow-lg transition-transform transform hover:scale-105"
                        >
                            <div className={`p-1 ${borderColor}`}></div>
                            <div className="p-8">
                                <h2 className="text-3xl font-bold text-gray-800 mb-4">
                                    {value}
                                </h2>
                                <p className="text-gray-600 mb-6">{subTitle}</p>
                            </div>
                            <div className="p-4">
                                <button
                                    className={`flex gap-x-1 items-center justify-center w-full text-white rounded-full px-4 py-2 focus:outline-none focus:shadow-outline-blue active:bg-blue-800 ${btnColor} hover:${btnHoverColor}`}
                                >
                                    <p>More info</p>
                                    <ArrowLongRightIcon className="w-6 h-6" />
                                </button>
                            </div>
                        </div>
                    )
                )}
            </div> */}
        </div>
        // <div className="content-wrapper">
        //     {/* Content Header (Page header) */}
        //     <div className="content-header">
        //         <div className="container-fluid">
        //             <div className="row mb-2">
        //                 <div className="col-sm-6">
        //                     <h1 className="m-0">Dashboard</h1>
        //                 </div>
        //                 {/* /.col */}
        //                 <div className="col-sm-6">
        //                     <ol className="breadcrumb float-sm-right">
        //                         <li className="breadcrumb-item">
        //                             <Link to="/">Home</Link>
        //                         </li>
        //                         <li className="breadcrumb-item active">
        //                             Dashboard
        //                         </li>
        //                     </ol>
        //                 </div>
        //                 {/* /.col */}
        //             </div>
        //             {/* /.row */}
        //         </div>
        //         {/* /.container-fluid */}
        //     </div>
        //     {/* /.content-header */}

        //     {/* Main content */}

        //     {isUserHaveNoPermission() ? (
        //         <section className="content">
        //             <div className="container-fluid">
        //                 <div className="alert alert-info alert-dismissible">
        //                     <button
        //                         type="button"
        //                         className="close"
        //                         data-dismiss="alert"
        //                         aria-hidden="true"
        //                     >
        //                         ×
        //                     </button>
        //                     <h5>
        //                         <i className="icon fas fa-info"></i> Welcome to
        //                         bdtickets CMS!
        //                     </h5>
        //                     As a new user, please note that you currently don't
        //                     have access to the menu options. To obtain the
        //                     necessary permissions, kindly contact your
        //                     administrator.
        //                 </div>
        //             </div>
        //         </section>
        //     ) : (
        //         userData?.roles ? dashBoardContent(userData?.roles) : ""
        //     )}
        //     {/* /.content */}
        // </div>
    );
};

export default Dashboard;
